import MvSelect from 'Generic/MvSelect';
import { MvTextOrEdit } from 'Generic/MvTextOrEdit';
import { GetCountriesResult } from 'Interfaces/GetReservations';
import Item from 'Interfaces/ItemInterface';
import React, { useEffect, useState } from 'react';
import ReservationService from 'Services/reservation.service';
import "./ModifyPrimaryGuestProfile.sass"

export interface Props {
    editGuestProfile: boolean;
    toggleEdit: () => void;
    localize: any;
    guestDetails: any;
    formValues: any;
    formErrors: any;
    setFormValues: (values: any) => void;
    setDefaultFormValues: (values: any) => void;
    countriesList: GetCountriesResult[];
    isStateRequired: boolean;
    setIsStateRequired: (value: boolean) => void;
    setStateUniqueKey: any;
    isZipCodeRequired: boolean;
    setIsZipCodeRequired: (value: boolean) => void;
};

/**
 * TODO: Describe this component!
 */
const ModifyPrimaryGuestProfile = ({
    toggleEdit,
    editGuestProfile,
    guestDetails,
    localize,
    formValues,
    formErrors,
    setFormValues,
    setDefaultFormValues,
    countriesList,
    isStateRequired,
    setIsStateRequired,
    setStateUniqueKey,
    isZipCodeRequired,
    setIsZipCodeRequired
}: Props) => {
    const [stateList, setStateList] = useState<GetCountriesResult[]>([]);
    const [updatedAddress, setupdatedAddress] = useState([]);
    const [currentCountry, setcurrentCountry] = useState([]) as any;
    const [currentState, setcurrentState] = useState([]) as any;
    const [currentStateProvince, setcurrentStateProvince] = useState([]) as any;
    const [currentStateProvinceObject, setcurrentStateProvinceObject] = useState([]) as any;
    const handleInputChange = (fieldName: string, value: string) => {
        setFormValues({ ...formValues, [fieldName]: value });
    }

    useEffect(() => {
        const reservationService = new ReservationService();
        
        if (guestDetails) {
        const { address } = guestDetails;
        reservationService.getCountries().then((response: GetCountriesResult[]) => {
        setupdatedAddress(address);
        });
        }
    }, [guestDetails]);

    useEffect(() => {
        if(updatedAddress) {
            const {state, stateProvince, country} = updatedAddress as any;
            const selectedCountry = countriesList.find(x => x.ID == country) as any;
            setcurrentCountry(selectedCountry);
            setcurrentStateProvince(stateProvince);
        }
    }, [updatedAddress]);

    useEffect(() => {
        if(currentCountry) {
            setcurrentState(currentCountry.State);
        }
    }, [currentCountry])

    useEffect(() => {
        if(currentState && currentStateProvince) {
            const selectedState = stateList.find(x => x.Description == currentStateProvince) as any;
            setcurrentStateProvinceObject(selectedState);
        }
    }, [currentState, currentStateProvince]);

    useEffect(() => {
        if(currentStateProvinceObject) {
            const selectedStateKey = currentStateProvinceObject.ID;
            handleSelectChangeState(selectedStateKey);
            setIsStateRequired(false);
            setStateUniqueKey(selectedStateKey);
        }
    }, [currentStateProvinceObject])

    const handleSelectChange = (valueFieldName: string, descriptionFieldName: string, data: any) => {
        if (valueFieldName === 'country') {
            const selectedCountry = countriesList.find(x => x.ID == data.value)
            if (selectedCountry) {
                setFormValues({ ...formValues, [valueFieldName]: parseInt(data.value), [descriptionFieldName]: selectedCountry.Name, state: '', stateDescription: '' });
                setStateList(selectedCountry.State);
                if (selectedCountry.State && selectedCountry.State.length > 0) {
                    setIsStateRequired(true)
                } else {
                    setIsStateRequired(false)
                }
                setIsZipCodeRequired(selectedCountry.zipCodeRequired)
            }
        }
        if (valueFieldName === 'state' && stateList) {
            const selectedState = stateList.find(x => x.ID == data.value)
            if (selectedState) {
                setFormValues({ ...formValues, [valueFieldName]: parseInt(data.value), [descriptionFieldName]: selectedState.Name  });
            }
        }
    }

    const handleSelectChangeState = (selectedState: any) => {
            setFormValues({ ...formValues, state: selectedState  });
    }

    const getInitialGuestDetails = () => {
        if (guestDetails) {
            const { firstName, lastName, address, phone, email, memberships } = guestDetails;
            let initialAddress = {};
            if (address) {
                const { addressLine1, addressLine2, addressLine3, city, state, stateDescription, stateProvince, country, countryDescription, postalCode } = address;
                initialAddress = { addressLine1, addressLine2, addressLine3, city, state, stateDescription, country, countryDescription, postalCode };
                handleSelectChange('country', 'country', { value: country })
            }
            let initialPhone = { code: '', phoneNumber: '' }
            if (typeof phone == 'object') {
                const { code , phoneNumber } = phone;
                initialPhone = { code: code || '' , phoneNumber };
            } else {
                initialPhone = { code: '' , phoneNumber: phone };
            }
            const membershipId = (memberships && memberships.length) ? memberships[0].membershipId: ""
            const initialFormValues = { firstName, lastName, email, bonvoyNumber: membershipId, ...initialAddress, phoneNumber: initialPhone.code + '' + initialPhone.phoneNumber };
            return initialFormValues;
        }
        return {};
    }

    useEffect(() => {
        if (guestDetails) {
            const initialFormValues = getInitialGuestDetails();
            setDefaultFormValues(initialFormValues);
        }
    }, [guestDetails])

    return (
        <>{editGuestProfile && <div className='modify-primary-guest-profile'>
            <div className='row'>
                <div className='twenty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('firstName', val)}
                        onBlur={(e) => { }}
                        value={formValues['firstName']}
                        placeholder={localize("static.content.firstname")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.firstname")}
                        id={'add_guest_first_name'}
                        name={'add_guest_first_name'}
                        hasError={formErrors['firstName']}
                        errorMessage={'First Name is Required'}
                        isRequired={true}
                        inputComponent='text'
                    />
                </div>
                <div className='twenty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('lastName', val)}
                        onBlur={(e) => { }}
                        value={formValues['lastName']}
                        placeholder={localize("static.content.lastname")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.lastname")}
                        id={'add_guest_last_name'}
                        name={'add_guest_last_name'}
                        hasError={formErrors['lastName']}
                        errorMessage={'Last Name is Required'}
                        isRequired={true}
                        inputComponent='text'
                    />
                </div>
                <div className='thirty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('addressLine1', val)}
                        onBlur={(e) => { }}
                        value={formValues['addressLine1']}
                        placeholder={localize("static.content.address-line1")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.address-line1")}
                        id={'add_guest_address_line1'}
                        name={'add_guest_address_line1'}
                        hasError={formErrors['addressLine1']}
                        errorMessage={'Address Line 1 is Required'}
                        isRequired={true}
                        inputComponent='text'
                    />
                </div>
                <div className='thirty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('addressLine2', val)}
                        onBlur={(e) => { }}
                        value={formValues['addressLine2']}
                        placeholder={localize("static.content.address-line-2")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.address-line-2")} 
                        id={'add_guest_address_line2'}
                        name={'add_guest_address_line2'}
                        hasError={false}
                        errorMessage={'Address Line 2 is Required'}
                        isRequired={false}
                        inputComponent='text'
                    />
                </div>
            </div>
            <div className='row'>
                <div className='fifty column'>
                    <label className={`input-label required`}><b>{localize("static.content.country-region")}</b></label>
                    <MvSelect
                        name={'add_guest_country'}
                        onChange={(e: any) => handleSelectChange('country', 'countryDescription', e.target)}
                        value={formValues['country']}
                        label={localize("static.content.country-region")}
                        required={true}
                        hasError={formErrors['country']}
                        items={(countriesList || []).map(x => ({ value: x.ID, name: x.Name, description: x.Name || '' } as Item))}
                        tabIndex={0}
                    />
                </div>
                <div className='fifty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('city', val)}
                        onBlur={(e) => { }}
                        value={formValues['city']}
                        placeholder={localize("static.content.city")}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.city")}
                        id={'add_guest_city'}
                        name={'add_guest_city'}
                        hasError={formErrors['city']}
                        errorMessage={'City is Required'}
                        isRequired={true}
                        inputComponent='text'
                    />
                </div>
                <div className='fifty column'>
                    <label className={`input-label required`}><b>{localize("static.content.state-province")}</b></label>
                    <MvSelect
                        name={'add_guest_state'}
                        onChange={(e: any) => handleSelectChange('state', 'stateDescription', e.target)}
                        value={formValues['state']}
                        label={localize("static.content.state-province")}
                        required={isStateRequired}
                        hasError={isStateRequired ? formErrors['state'] : false}
                        items={(stateList || []).map(x => ({ value: x.ID, name: x.Name, description: x.Description || '' } as Item))}
                        tabIndex={0}
                    />
                </div>
                <div className='fifty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('postalCode', val)}
                        onBlur={(e) => { }}
                        value={formValues['postalCode']}
                        placeholder={localize("static.content.zip")}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.zip")}
                        id={'add_guest_zip'}
                        name={'add_guest_zip'}
                        hasError={isZipCodeRequired ? formErrors['postalCode'] : false}
                        errorMessage={formValues['postalCode'] ? 'Zip/Postal Code is Invalid' : 'Zip/Postal Code is Required'}
                        isRequired={isZipCodeRequired}
                        inputComponent='text'
                    />
                </div>
                <div className='fifty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('phoneNumber', val)}
                        onBlur={(e) => { }}
                        value={formValues['phoneNumber']}
                        placeholder={localize("static.content.sr-phone")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.sr-phone")}
                        id={'add_guest_phone'}
                        name={'add_guest_phone'}
                        hasError={formErrors['phoneNumber']}
                        errorMessage={'Enter Phone Number upto 14 digits without special characters '}
                        isRequired={false}
                        tooltip={localize("static.content.sr-phone-tooltip")}
                        inputComponent='text'
                    />
                </div>
            </div>
            <div className='row'>
                <div className='thirty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('email', val)}
                        onBlur={(e) => { }}
                        value={formValues['email']}
                        placeholder={localize("static.content.email")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={true}
                        hideLabel={false}
                        label={localize("static.content.email")}
                        id={'add_guest_email'}
                        name={'add_guest_email'}
                        hasError={formErrors['email']}
                        errorMessage={'Email is Required'}
                        isRequired={true}
                        inputComponent='text'
                    />
                </div>
                <div className='twenty column'>
                    <MvTextOrEdit
                        onChange={(val) => handleInputChange('bonvoyNumber', val)}
                        onBlur={(e) => { }}
                        value={formValues['bonvoyNumber']}
                        placeholder={localize('static.content.marriott-bonvoy-number')}
                        isEditing={true}
                        hideLabel={false}
                        label={localize('static.content.marriott-bonvoy-number')}
                        id={'add_guest_membershipId'}
                        name={'add_guest_membershipId'}
                        hasError={formErrors['bonvoyNumber']}
                        errorMessage={'Enter 9 digit Marriot Bonvoy Number without special characters'}
                        isRequired={false}
                        inputComponent='text'
                    />
                </div>
                <div className='fifty column'></div>
            </div>
        </div>}
        </>
    );
};

export {
    ModifyPrimaryGuestProfile,
};
